var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuildCampus(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 264.937,
    height: 203.492,
    viewBox: "0 0 264.937 203.492",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke-linecap: round;\n        stroke-width: 4px;\n      }\n\n      .cls-2, .cls-3 {\n        stroke: #1228f3;\n      }\n\n      .cls-3 {\n        fill: #c2c7fb;\n      }\n\n      .cls-4, .cls-5 {\n        stroke: none;\n      }\n\n      .cls-5 {\n        fill: #1228f3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Build_the_Campus_1024",
    "data-name": "Build the Campus 1024",
    transform: "translate(0.287 9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40472",
    "data-name": "Group 40472",
    transform: "translate(0 -9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_65447",
    "data-name": "Path 65447",
    className: "cls-1",
    transform: "translate(7553.097 -1647.443)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M -7420.98291015625 1799.19384765625 L -7552.3798828125 1723.516723632812 L -7420.8125 1648.019775390625 L -7289.49609375 1723.30419921875 L -7420.98291015625 1799.19384765625 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M -7420.8125 1648.59619140625 L -7551.376953125 1723.517456054688 L -7420.98291015625 1798.61669921875 L -7290.49853515625 1723.3056640625 L -7420.8125 1648.59619140625 M -7420.8125 1647.443359375 L -7288.4931640625 1723.302734375 L -7420.982421875 1799.77099609375 L -7553.38330078125 1723.515869140625 L -7420.8125 1647.443359375 Z"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_225",
    "data-name": "Line 225",
    className: "cls-2",
    x1: 41.301,
    y2: 23.983,
    transform: "translate(111.685 51.012)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_226",
    "data-name": "Line 226",
    className: "cls-2",
    x2: 41.531,
    y2: 23.829,
    transform: "translate(111.454 51.012)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68406",
    "data-name": "Path 68406",
    className: "cls-3",
    d: "M-13020.267,1916.553l.162,50.5-131.825-74.813v-50.875Z",
    transform: "translate(13152.219 -1773.425)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_68407",
    "data-name": "Path 68407",
    className: "cls-1",
    transform: "translate(13328.253 -1731.311)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M -13195.1748046875 1924.92138671875 L -13195.35546875 1874.489135742188 L -13064.1806640625 1798.980224609375 L -13064.103515625 1850.544311523438 L -13195.1748046875 1924.92138671875 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M -13194.677734375 1924.064575195312 L -13064.6044921875 1850.25341796875 L -13064.6787109375 1799.84423828125 L -13194.8544921875 1874.777709960938 L -13194.677734375 1924.064575195312 M -13195.671875 1925.7783203125 L -13195.8564453125 1874.20068359375 L -13063.681640625 1798.1162109375 L -13063.603515625 1850.835205078125 L -13195.671875 1925.7783203125 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildCampus);
export default __webpack_public_path__ + "static/media/build-campus.b41eb4436fa6986504c5720a3b0be041.svg";
export { ForwardRef as ReactComponent };